import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { addUnit, getUnits, deleteUnit } from '../../../views/spenza/utils/admin'

const UnitsContext = createContext();

export const useUnits = () => useContext(UnitsContext);

export const UnitsProvider = ({ children }) => {
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchUnits = async () => {
    setLoading(true);
    const unitsResult = await getUnits();
    unitsResult.sort((a, b) => b.dateCreated.seconds - a.dateCreated.seconds);
    setUnits(unitsResult);
    setLoading(false);
  }

  const createUnits = async (newUnit) => {
    setLoading(true);
    await addUnit(newUnit);
    await fetchUnits();
    setLoading(false);
  };

  const removeUnit = (unit) => {
    deleteUnit(unit.id);
    const newUnits = units.filter(u => u.id !== unit.id)
    setUnits(newUnits);
  };

  useEffect(() => {
    fetchUnits();
  }, []);

  return (
    <UnitsContext.Provider
      value={{
        units,
        createUnits,
        removeUnit,
        fetchUnits,
        loading,
      }}
    >
      {children}
    </UnitsContext.Provider>
  );
};

UnitsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};